import { createSelector } from 'reselect';

const selectCache = (state: any) => state.app;

export const selectSignOutState = createSelector(
  selectCache,
  (cache: any) => cache.isSignOutLoading
);

export const selectIsLoading = createSelector(
  selectCache,
  (cache: any) => cache.loading
);

export const selectTheme = createSelector(
  selectCache,
  (cache: any) => cache.theme
);

export const selectLang = createSelector(
  selectCache,
  (cache: any) => cache.language
);

export const selectAppUserRole = createSelector(
  selectCache,
  (cache: any) => cache.userRole
);

export const selectAppError = createSelector(
  selectCache,
  (cache: any) => cache.error
);

export const selectLoginType = createSelector(
  selectCache,
  (cache: any) => cache.loginType
);

export const selectMapSearchLocationHistory = createSelector(
  selectCache,
  (cache: any) => cache.mapSearchLocationHistory
);

export const selectHeaderPanelExpand = createSelector(
  selectCache,
  (cache: any) => cache.headerPanelExpand
);

export const selectBaseMap = createSelector(
  selectCache,
  (cache: any) => cache.selectedBasemap
);

export const selectBaseMapTheme = createSelector(
  selectCache,
  (cache: any) => cache.baseMapTheme
);

export const selectAppVisiblePanel = createSelector(
  selectCache,
  (cache: any) => cache.appVisiblePanel
);

export const selectShowCLOListing = createSelector(
  selectCache,
  (cache: any) => cache.showCLOListing
);

export const selectShowInterstitialPage = createSelector(
  selectCache,
  (cache: any) => cache.showInterstitialPage
);
